import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { FoundationModule } from '../../foundation.module';
import { FnDateEventFilterComponent } from './fn-date-event-filter.component';
import { FnInputModule } from '../input/index';
import { FnButtonModule } from '../button/index';
import { FnScrollbarModule } from '../scrollbar/index';
import { FnDatePickerModule } from '../date-picker';
import { FnDateRangePickerModule } from '../date-range';

export * from './fn-date-event-filter.component';


/**
 * Exports the required FnDatePickerComponent to create datePicker Element
 * making them available for import by NgModules that import this module.
 */

@NgModule({
  declarations: [FnDateEventFilterComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FoundationModule,
    FnInputModule,
    FnButtonModule,
    FnScrollbarModule,
    FnDateRangePickerModule,
    FnDatePickerModule

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [FnDateEventFilterComponent],
})
export class FnDateEventFilterModule { }
